import { Region } from "./region";
import { Job } from "./job";
import { Team } from "./team";
import { Studio } from "./studio";
import { Offer } from "./offer";
import { OfferAllocation } from "./offerAllocation";
import { ValidationError } from "./validationError";
import { PageBackground } from "./pageBackground";
import { PageTemplate } from "./pageTemplate";

export class DocumentSegment{
    id:number;
    height?:number;
    label?:string;
    pageText?:string;
    prAttId?:number;
    offerAllocationCount:number;
    offerAssignedCount:number;
    section?:number;
    segmentIdentifier?:string;
    segmentNumber?:string;
    smallPrAttId?:number;
    studios?:string;
    studioArray?:Studio[];
    thAttId?:number;
    uuid:string;
    width?:number;
    x?:number;
    xml?:number;
    y?:number;
    z?:number;
    teams?:Team[];
    publicOffers?:Offer[];
    offerAllocation?:OfferAllocation[];
    lockStatus?:string;
    validationErrors?:ValidationError;
    pageBackground?:any;
    totalSales?:string;
    pageTemplate?:PageTemplate;
    unit?:string;
    dsTeams?:any[];

    get isLocked():boolean{
      return this.lockStatus === "T"?true:false;
    }
}
export class DocSegmentMenuEvent{
  type?:string;
  documentSegment?:DocumentSegment;
  job:Job;
  offer:Offer;
}
export const DocSegmentMenuEventType = {
  EDIT_JOB: 'EDIT_SEGMENT',
  ADD_JOB: 'ADD_SEGMENT',
  DELETE_JOB:'DELETE_SEGMENT',
  NOTIFY_TEAMS:'NOTIFY_TEAMS_SEGMENT',
  ASSIGN_TEMPLATES:'SEGMENT_ASSIGN_TEMPLATES',
  CREATE_OFFER:'SEGMENT_CREATE_OFFER',
  APPLY_TEAMS:'APPLY_TEAMS_SEGMENT',
  APPLY_STUDIOS:'APPLY_STUDIOS_SEGMENT',
  SEND_TO_STUDIO:'SEND_TO_STUDIO_SEGMENT',
  LOCK:'LOCK_SEGMENT',
  ASSIGN_OFFER:'SEGMENT_ASSIGN_OFFER',
  MANAGE_ALLOC:'MANAGE_ALLOC',
  GENERATE_REPORT:'SEGMENT_GENERATE_REPORT',
  DISPLAY_REPORTS:'SEGMENT_DISPLAY_REPORTS',
  APPLY_BACKGROUND:'APPLY_BACKGROUND_GROUP',
  // NOTIFY_TEAMS:'NOTIFY_TEAMS',
};
export class SegmentGroupMenuEvent{
  type?:string;
  documentSegment?:DocumentSegment;
  jobs?:Job[];
  job:Job;
  custom?:any;
}
export const SegmentGroupMenuEventType = {
  EDIT_JOB: 'EDIT_GROUP',
  ADD_JOB: 'ADD_GROUP',
  DELETE_JOB:'DELETE_GROUP',
  NOTIFY_TEAMS:'NOTIFY_TEAMS_GROUP',
  APPLY_TEAMS:'APPLY_TEAMS_GROUP',
  APPLY_STUDIOS:'APPLY_STUDIOS_GROUP',
  SEND_TO_STUDIO:'SEND_TO_STUDIO_GROUP',
  SWAP_SEGMENTS:'SWAP_SEGMENTS_GROUP',
  EDIT_LABEL:'EDIT_SEGMENTS_LABEL_GROUP',
  APPLY_BACKGROUND:'APPLY_BACKGROUND_GROUP',
  GENERATE_REPORT:'GENERATE_REPORT_GROUP',
  // NOTIFY_TEAMS:'NOTIFY_TEAMS',
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/documentSegment.ts